import * as THREE from 'three';
import { CanvasListenersType, DrainFunnelObjectType } from '../types';
import {
  EventSelectControlPoint,
  EventSelectControlPointDetailType,
  EventSelectDrainFunnel,
  EventSelectDrainFunnelDetailType,
  EventSelectLinkingDetailType,
  EventSelectLinkingLine,
} from '../../helpers/events';
import LinkingPointObject from '../meshes/LinkingPointObject';
import ControlPoint from '../meshes/ControlPoint';
import { Edit } from './Edit';

interface Props {
  element: HTMLCanvasElement;
  widthContainer: number;
  heightContainer: number;
  camera: THREE.OrthographicCamera;
}
export default ({
  camera,
  widthContainer,
  heightContainer,
  element,
}: Props): CanvasListenersType => {
  const rayCast = new THREE.Raycaster();
  const mouse = {
    x: 0,
    y: 0,
  };

  const LISTENERS: CanvasListenersType = {
    camera,
    widthContainer,
    heightContainer,
    objectsIntersects: [],
    domElement: element,

    activateListeners() {
      if (this.domElement) {
        if (window.PointerEvent) {
          this.domElement.addEventListener('pointerdown', constructorMouseDown);
          this.domElement.addEventListener('pointermove', constructorMouseMove);
          this.domElement.addEventListener('pointerup', constructorMouseUp);
          this.domElement.addEventListener('contextmenu', onContextMenu);
        } //
        else {
          // this.domElement.addEventListener('mousedown', ListenersCanvas.constructorMouseDown);
          // this.domElement.addEventListener('mousemove', ListenersCanvas.constructorMouseMove);
          // this.domElement.addEventListener('mouseup', ListenersCanvas.constructorMouseUp);
          // this.domElement.addEventListener("touchstart", constructorTouchStart);
          // this.domElement.addEventListener("touchmove", constructorTouchMove);
          // this.domElement.addEventListener("touchend", constructorTouchEnd);
        }
      }
    },
    deactivateListeners() {
      if (this.domElement) {
        if (window.PointerEvent) {
          this.domElement.removeEventListener('pointerdown', constructorMouseDown);
          this.domElement.removeEventListener('pointermove', constructorMouseMove);
          this.domElement.removeEventListener('pointerup', constructorMouseUp);
          this.domElement.removeEventListener('contextmenu', onContextMenu);
        } //--
        else {
          // this.domElement.removeEventListener('mousedown', ListenersCanvas.constructorMouseDown);
          // this.domElement.removeEventListener('mousemove', ListenersCanvas.constructorMouseMove);
          // this.domElement.removeEventListener('mouseup', ListenersCanvas.constructorMouseUp);
          // this.domElement.removeEventListener("touchstart", constructorTouchStart);
          // this.domElement.removeEventListener("touchmove", constructorTouchMove);
          // this.domElement.removeEventListener("touchend", constructorTouchEnd);
        }
      }
    },
    addObjectsIntersected(obj: THREE.Object3D) {
      this.objectsIntersects.push(obj);
    },
    removeObjectsIntersected(uuidObj: string) {
      const index = this.objectsIntersects.findIndex(item => item.uuid === uuidObj);
      if (index !== -1) {
        this.objectsIntersects.splice(index, 1);
      }
    },
  };
  return LISTENERS;

  function convertCoordinateDomInThree(event: PointerEvent): THREE.Vector2 {
    // if (event.type.indexOf("touch") !== -1) {
    //   const rect = ListenersCanvas.currentInstance.domElement.getBoundingClientRect();
    //   ListenersCanvas.currentInstance.mouse.x = ((event.changedTouches[0].clientX - rect.left) / rect.width) * 2 - 1;
    //   ListenersCanvas.currentInstance.mouse.y = -((event.changedTouches[0].clientY - rect.top) / rect.height) * 2 + 1;
    // } else {
    //   ListenersCanvas.currentInstance.mouse.x = (event.offsetX / LOAD.widthContainer) * 2 - 1;
    //   ListenersCanvas.currentInstance.mouse.y = -(event.offsetY / LOAD.heightContainer) * 2 + 1;
    // }

    mouse.x = (event.offsetX / LISTENERS.widthContainer) * 2 - 1;
    mouse.y = -(event.offsetY / LISTENERS.heightContainer) * 2 + 1;

    // const swipe = new THREE.Vector3();
    // swipe.set(ListenersCanvas.mouse.x, ListenersCanvas.mouse.y, 0);
    // swipe.unproject(ListenersCanvas.currentInstance.camera).setY(0);
    // return swipe;
    return new THREE.Vector2(event.offsetX, event.offsetY);
  }
  function constructorMouseDown(event: PointerEvent) {
    event.preventDefault();

    const coordinates = convertCoordinateDomInThree(event);
    rayCast.setFromCamera(mouse, LISTENERS.camera);
    const inters = rayCast.intersectObjects(LISTENERS.objectsIntersects, true);
    switch (event.buttons) {
      case 1:
        if (Edit.lineObject) {
          Edit.removeLineObject(true);
        }
        break;
      case 2:
        if (Edit.lineObject) {
          Edit.removeLineObject(false);
        }
        if (inters.length) {
          if (inters[0].object instanceof LinkingPointObject) {
            document.dispatchEvent(
              new CustomEvent<EventSelectLinkingDetailType>(EventSelectLinkingLine, {
                detail: {
                  position: coordinates,
                  selectObject: inters[0].object,
                },
              })
            );
          } //
          else if (inters[0].object instanceof ControlPoint) {
            if (Edit?.dragObject?.dragControls?.enabled) {
              Edit.dragObject.dragControls.enabled = false;
            }
            document.dispatchEvent(
              new CustomEvent<EventSelectControlPointDetailType>(EventSelectControlPoint, {
                detail: {
                  position: coordinates,
                  selectObject: inters[0].object,
                },
              })
            );
          } //
          else if (inters[0].object.name === 'point_funnel_move') {
            document.dispatchEvent(
              new CustomEvent<EventSelectDrainFunnelDetailType>(EventSelectDrainFunnel, {
                detail: {
                  position: coordinates,
                  selectObject: inters[0].object.parent as DrainFunnelObjectType,
                  uuidPointMove: inters[0].object.uuid,
                },
              })
            );
          }
        }
        break;
    }

    return false;
  }
  function constructorMouseMove(event: PointerEvent) {
    event.preventDefault();
    convertCoordinateDomInThree(event);
    const swipe = new THREE.Vector3();
    swipe.set(mouse.x, mouse.y, 0);
    swipe.unproject(camera).setY(0);
    if (Edit.lineObject) {
      Edit.lineObject.updateLineGeometry(swipe);
    }
    // console.log(swipe);
  }
  function constructorMouseUp(event: PointerEvent) {
    event.preventDefault();

    switch (event.buttons) {
      case 1:
        break;
      case 2:
        if (Edit?.dragObject?.dragControls) {
          Edit.dragObject.dragControls.enabled = true;
        }
        break;
    }
  }
  function onContextMenu(event: Event) {
    event.preventDefault();
    return false;
  }
};
